module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("Publisher: Amy Marson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Creative Director: Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Editors: Karla Menaugh and Liz Aneloski")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Technical Editors: Sadhana Wray and Debbie Rodgers")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover/Book Designer: April Mostek")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Production Coordinators: Freesia Pearson Blizard and Zinnia Heinzmann")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Production Editors: Jennifer Warren and Nicole RolandelliPhoto Assistant: Carly Jean Marin")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Photography by Diane Pedersen, unless otherwise noted")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published by C&T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2710f8b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 60
// module chunks = 0